// extracted by mini-css-extract-plugin
export default {"button":"button_button__mIIpx","secondaireButton":"button_secondaireButton__QmG4x"};